import { render, staticRenderFns } from "./UploadCertificate.vue?vue&type=template&id=0ebcbaa8"
import script from "./UploadCertificate.vue?vue&type=script&lang=ts"
export * from "./UploadCertificate.vue?vue&type=script&lang=ts"
import style0 from "./UploadCertificate.vue?vue&type=style&index=0&id=0ebcbaa8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports